var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "FlyerlineModal",
        { staticClass: "flyerline-modal--small", attrs: { name: _vm.name } },
        [
          _vm.user
            ? _c("div", [
                _c("h3", { staticClass: "text-shade-darker" }, [
                  _vm._v(_vm._s(_vm._f("translate")("txtSaveOrder"))),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text-small mb-prj2" }, [
                  _vm._v(_vm._s(_vm._f("translate")("txtSaveOrderModal"))),
                ]),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass:
                      "label-aligned text-small mb-prj d-block line-height-14",
                    attrs: { for: "configName-id" },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm._f("translate")("txtSaveOrderModalLabel"))
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.configName,
                      expression: "configName",
                    },
                  ],
                  attrs: { id: "configName-id" },
                  domProps: { value: _vm.configName },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.configName = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass:
                      "mt-2 mt-3@large btn btn--prj-min-x w-100@until-medium",
                    on: {
                      click: function ($event) {
                        return _vm.$emit("saveConfiguration", _vm.configName)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(this.buttonLabel) +
                        "\n            "
                    ),
                  ]
                ),
              ])
            : _c(
                "div",
                [
                  _c("p", { staticClass: "h3 text-shade-darker mt-0 mb-2" }, [
                    _vm._v(_vm._s(_vm._f("translate")("txtLogin"))),
                  ]),
                  _vm._v(" "),
                  _c("SkyFormLoader", {
                    attrs: { "form-name": "prj_shop_login" },
                    on: { success: _vm.handleLogin },
                  }),
                ],
                1
              ),
        ]
      ),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }